<template>
  <div class="card shadow">
    <div class="card-header">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'articles' }">Articles</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Edit Article
          </li>
        </ol>
      </nav>
    </div>
    <div class="card-body" v-loading="loading">
      <article-item-detail v-if="!loading" :article="article" />
    </div>
  </div>
</template>

<script>
import ArticleItemDetail from '@/components/Article/Item/ArticleItemDetail'

export default {
  data() {
    return {
      loading: true,
      article: {},
    }
  },
  mounted() {
    this.getArticle()
  },
  components: {
    ArticleItemDetail,
  },
  methods: {
    async getArticle() {
      this.loading = true
      try {
        var { data } = await this.$http.get(`/articles/${ this.$route.params.id }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }
      this.article = data
    },
  },
}
</script>
